import { render, staticRenderFns } from "./AppOverallAssessmentReport.vue?vue&type=template&id=077c4a33&scoped=true"
import script from "./AppOverallAssessmentReport.vue?vue&type=script&lang=ts"
export * from "./AppOverallAssessmentReport.vue?vue&type=script&lang=ts"
import style0 from "./AppOverallAssessmentReport.vue?vue&type=style&index=0&id=077c4a33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c4a33",
  null
  
)

export default component.exports